import React from 'react'
import styled from 'styled-components'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

const BgButton = styled(Button)({
  '&.MuiButton-root': {
    width: '100%', 
    marginTop: '8px',
    padding: '10px 0',    
    fontSize: '16px',
    fontWeight: '600',
    borderRadius: '8px',
    color: 'var(--text-white)',
    backgroundColor: 'var(--red-bnz)',
    border: 'none',
    boxShadow: 'none',
    textTransform: 'none',
    fontFamily: "'Inter', Helvetica, sans-serif",
  },
  '&.MuiButton-root:hover': {
    backgroundColor: '#F1747E',
  },
  '&.MuiButton-root:active': {
    backgroundColor: '#F1747E',
  },
  '&.MuiButton-root:focus': {
    boxShadow: 'none',
  },
  '&.MuiButton-root:disabled': {
    backgroundColor: 'var(--border-color)',
    color: 'var(--text-muted)',
  },
});

const BgButtonSecondary = styled(Button)({
  '&.MuiButton-root': {
    width: '100%', 
    marginTop: '8px',
    padding: '10px 0',       
    fontSize: '16px',
    fontWeight: '600',
    borderRadius: '8px',
    color: 'var(--text-white)',
    backgroundColor: 'var(--blue-dark)',
    border: 'none',
    boxShadow: 'none',
    textTransform: 'none',
    fontFamily: "'Inter', Helvetica, sans-serif",
  },
  '&.MuiButton-root:hover': {
    backgroundColor: 'var(--card-hover-bg)',
  },
  '&.MuiButton-root:active': {
    backgroundColor: 'var(--card-hover-bg)',
  },
  '&.MuiButton-root:focus': {
    boxShadow: 'none',
  },
  '&.MuiButton-root:disabled': {
    backgroundColor: 'var(--border-color)',
    color: 'var(--text-muted)',
  },
});

const ButtonIcon = styled(IconButton)({
  '&.MuiButton-root': {
    color: 'var(--text-white)',
    backgroundColor: 'var(--blue-dark)',
    border: 'none',
    boxShadow: 'none',
  },
  '&.MuiButton-root:hover': {
    backgroundColor: 'var(--card-hover-bg)',
  },
  '&.MuiButton-root:active': {
    backgroundColor: 'var(--card-hover-bg)',
  },
  '&.MuiButton-root:focus': {
    boxShadow: 'none',
  },
  '&.MuiButton-root:disabled': {
    backgroundColor: 'var(--border-color)',
    color: 'var(--text-muted)',
  },
});

const ButtonLink = styled(Button)({
  '&.MuiButton-root': {
    margin: '0',
    padding: '0',
    fontSize: '16px',
    fontWeight: '400',
    color: 'var(--text-color)',
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    textTransform: 'none',
    textDecoration: 'underline',
    fontFamily: "'Inter', Helvetica, sans-serif",
  },
  '&.MuiButton-root:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
    color: 'var(--text-secondary)',
  },
  '&.MuiButton-root:active': {
    color: 'var(--text-color)',
  },
  '&.MuiButton-root:focus': {
    boxShadow: 'none',
  },
  '&.MuiButton-root:disabled': {
    color: 'var(--text-muted)',
  },
});

const ButtonExternalLink = styled(Button)({
  '&.MuiButton-root': {
    margin: '0',
    padding: '0',
    fontSize: '14px',
    fontWeight: '400',
    fontStyle: 'italic',
    color: 'var(--purple-bnz)',
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    textTransform: 'none',
    fontFamily: "'Inter', Helvetica, sans-serif",
  },
  '&.MuiButton-root:hover': {
    backgroundColor: 'transparent',
    color: 'var(--purple-bnz)',
  },
  '&.MuiButton-root:active': {
    color: 'var(--purple-bnz)',
  },
  '&.MuiButton-root:focus': {
    boxShadow: 'none',
  },
  '&.MuiButton-root:disabled': {
    color: 'var(--text-muted)',
  },
});

const ButtonInputField = styled(Button)({
  '&.MuiButton-root': {
    margin: 0,
    padding: 0,
    minWidth: 0,
    fontSize: '14px',
    fontWeight: '500',
    color: 'var(--text-color)',
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    textTransform: 'none',
    fontFamily: "'Inter', Helvetica, sans-serif",
  },
  '&.MuiButton-root:hover': {
    backgroundColor: 'transparent',
    fontWeight: 700,
    color: 'var(--text-color)',
  },
  '&.MuiButton-root:active': {
    backgroundColor: 'transparent',
    fontWeight: 700,
    color: 'var(--text-color)',
  },
  '&.MuiButton-root:focus': {
    boxShadow: 'none',
  },
  '&.MuiButton-root:disabled': {
    color: 'var(--text-muted)',
  },
});

const LoginButtonForm = props => {
  if(props.buttonType === 'primaryButton') {
    return (
      <BgButton style={props.style} onClick={props.onClick || null} disabled={props.disabled} type={props.type || 'button'}>
        {props.children}
      </BgButton>
    )
  }
  if(props.buttonType === 'secondaryButton') {
    return (    
      <BgButtonSecondary style={props.style} onClick={props.onClick || null} disabled={props.disabled} type={props.type || 'button'}>
        {props.children}
      </BgButtonSecondary>
    )
  }  
  if(props.buttonType === 'iconButton') {
    return (    
      <ButtonIcon style={props.style} onClick={props.onClick || null} disabled={props.disabled} type={props.type || 'button'}>
        {props.children}
      </ButtonIcon>
    )
  }
  if(props.buttonType === 'linkButton') {
    return (    
      <ButtonLink style={props.style} onClick={props.onClick || null} disabled={props.disabled} type={props.type || 'button'}>
        {props.children}
      </ButtonLink>
    )
  }
  if(props.buttonType === 'externalLinkButton') {
    return (    
      <ButtonExternalLink style={props.style} onClick={props.onClick || null} disabled={props.disabled} type={props.type || 'button'}>
        {props.children}
      </ButtonExternalLink>
    )
  } 
  if(props.buttonType === 'inputFieldButton') {
    return (    
      <ButtonInputField style={props.style} onClick={props.onClick || null} disabled={props.disabled} type={props.type || 'button'}>
        {props.children}
      </ButtonInputField>
    )
  } 
}

export default LoginButtonForm